import { Controller } from "stimulus"

import tippy from 'tippy.js'

export default class extends Controller {
  static targets = []

  connect() {

    if (this.data.get('id')) {
      var current_pixel = this.element.querySelector(`.pixel[ids~="${this.data.get('id')}"]`)
      current_pixel.classList.add('is-current')
    }

    var pixels = this.element.querySelectorAll('.pixel')

    tippy(pixels, {
      // content: "<ul class='pixel-map__locations'><li class='pixel-map__location'>Basel</li><li class='pixel-map__location'>Liestal</li></ul>",
      content(reference) {
        var locations = JSON.parse(reference.getAttribute('loc'))
        var container = document.createElement('ul')

        locations.forEach(function(location) {
          var item = document.createElement('li')
          item.classList.add('pixel-map__location')

          // Create Link
          var link = document.createElement('a')
          link.setAttribute('href', location.url)

          // Create products
          var products = document.createElement('div')
          products.classList.add('pixel-map__location-products')
          products.innerHTML = location.products

          // Create Text
          var title = document.createElement('div')
          var title_text = document.createTextNode(location.name)
          title.classList.add('pixel-map__location-title')
          title.appendChild(title_text)
          var address = document.createElement('div')
          address.innerHTML = location.address
          address.classList.add('pixel-map__location-address')

          var info = document.createElement('div')
          info.classList.add('pixel-map__location-info')
          info.appendChild(title)
          info.appendChild(address)

          link.appendChild(products)
          link.appendChild(info)

          item.appendChild(link)
          container.appendChild(item)
        })

        container.classList.add('pixel-map__locations')
        return container
      },
      theme: 'light',
      interactive: true,
      arrow: true,
      // onShow(instance) {
      //   instance.setContent(instance.reference.getAttribute('location-ids'))
      // }
    })
    // animateFill: false,
    // animation: '',
    // arrow: true,
    // duration: [0,0],
    // distance: 20,
    // size: 'small',
    // )

  }

  teardown() {
    document.querySelectorAll('.tippy-popper').forEach(function(element) {
      element.remove()
    })
  }
}
